import { findHighestZIndex } from "../../utils/util";

export interface IDrawerModel {
    componentName: string;
    props?: Object;
    title?: string;
    subTitle?: string;
    context?: string;
    zIndex?: number;
    showSaveBtn?: boolean;
    actionLabel?: string;
}

export class DrawerModel implements IDrawerModel {
    componentName: string;
    props?: Object;
    title?: string;
    subTitle?: string;
    context?: string;
    zIndex?: number;
    showSaveBtn?: boolean;
    actionLabel?: string;

    constructor(option: IDrawerModel) {
        this.componentName = option.componentName;
        this.props = option.props || {};
        this.title = option.title || null;
        this.context = option.context || null;
        this.zIndex = option.zIndex || findHighestZIndex('el-dialog__wrapper') + 1;
        this.showSaveBtn = option.showSaveBtn || false;
        this.actionLabel = option.actionLabel || null;
        this.subTitle = option.subTitle || null;
    }
}